import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import './LanguageSwitcher.css';

const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

interface LSI {
    operator: string;
    languages: string[];
    language: string;
}

const flagUrls: { [key: string]: string } = {
    en: '/assets/img/flags/uk.svg',
    de: '/assets/img/flags/germany.svg',
    sv: '/assets/img/flags/sweden.svg',
    fr: '/assets/img/flags/france.svg',
    es: '/assets/img/flags/spain.svg',
    ptBR: '/assets/img/flags/brazil.svg',
    swTZ: '/assets/img/flags/kenya.svg',
};

const LanguageSwitcher: React.FC<LSI> = ({ languages, language }) => {
    const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);
    const operatorLanguages = languages.length > 0 ? languages : language ? [language] : ['en'];

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        setCurrentLanguage(lng);
    };

    useEffect(() => {
        const handleLanguageChange = (lng: string) => {
            setCurrentLanguage(lng);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    return (
        <>
            {
                operatorLanguages.length === 1 ? null
                    :
                    <div className="text-center mb-3 languageSelector">
                        {operatorLanguages.map((lng) => (
                            <span
                                key={lng}
                                style={{
                                    backgroundImage: `url(${toAbsoluteUrl(flagUrls[lng] || flagUrls['en'])})`,
                                }}
                                onClick={() => changeLanguage(lng)}
                                className={currentLanguage === lng ? 'active-lang btn mt-3' : 'btn mt-3'}
                            />
                        ))}
                    </div>
            }
        </>
    );
};

export default LanguageSwitcher;
